import React from 'react'

const ContactUs: React.FunctionComponent = () => {
  return (
    <div className='d-flex justify-content-center'>
      <iframe
        title='Support Form'
        className='text-center'
        width={650}
        height={550}
        src='../support.html'
      ></iframe>
    </div>
  )
}

export default ContactUs
